// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7391c188","453":"08ec18bb","455":"9e7b5d81","977":"fe0967a5"}[chunkId] + ".chunk.js";
};